<template>
  <BaseSystemSummary />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
